// import React from 'react'
// import { Typography, Stack, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import { fetchData, youtubeOptions } from '../utils/fetchData';
import BodyPartImage from '../assets/icons/body-part.png'
import TargetImage from '../assets/icons/target.png'
import EquipmentImage from '../assets/icons/equipment.png'

const youtubeSearchUrl = 'https://youtube-search-and-download.p.rapidapi.com';


const Detail = ({ exerciseDetail }) => {
  const { bodyPart, gifUrl, name, target, equipment } = exerciseDetail;
  const [thumbnail, setThumbnail] = useState('');
  useEffect(() => {
    const fetchThumbnail = async () => {
      try {
        const searchQuery = `${youtubeSearchUrl}/search?query=${name}`;
        const youtubeData = await fetchData(searchQuery, youtubeOptions);

        // ✅ Filter out YouTube Shorts
        const nonShorts = youtubeData?.contents?.filter(
          (item) => item.video && !item.video.isShort
        );

        const thumbnails = nonShorts?.[0]?.video?.thumbnails;
const bestThumbnail = thumbnails?.[thumbnails.length - 1]?.url;


if (bestThumbnail) {
  setThumbnail(bestThumbnail);
} else {
  setThumbnail('/fallback.png');
}

      } catch (error) {
        console.error('Failed to fetch YouTube thumbnail:', error);
        setThumbnail('/fallback.png'); // 👈 fallback on error
      }
    };

    fetchThumbnail();
  }, [name]);


  const extraDetail = [
    {
        icon: BodyPartImage,
        name: bodyPart,
    },
    {
        icon: TargetImage,
        name: target,
    },
    {
        icon: EquipmentImage,
        name: equipment,
    },
  ]

    return (
    <Stack gap="60px" sx={{flexDirection: { lg: 'row'}, p: '20px', alignItems: 'center'}}>
        <img src={thumbnail} alt={name} loading="lazy" className="detail-image" />
        <Stack sx={{ gap: { lg: '35px', xs: '20px' }}}>
            <Typography variant="h3">
                {name}
            </Typography>
            <Typography variant="h6">
                Exercises keep you strong. {name} {' '}
                
                is one of the best exercises to target your {target}. It will help you improve your mood and gain energy.
            </Typography>
            {extraDetail.map((item) => (
                <Stack key={item.name} direction="row" gap="24px" alignItems="center">
                    <Button sx={{ background: '#fff2db', borderRadiu: '50%', width: '100px', height: '100px'}}>
                        <img src={item.icon} alt={bodyPart} style={{ width: '50px', height: '50px'}}/>
                    </Button>
                    <Typography textTransform="capitalize" variant="h5">
                        {item.name}
                    </Typography>
                </Stack>
            ))}
    </Stack>
    </Stack>
  )
}

export default Detail